module.exports = __webpack_public_path__ + "img/circle_off.adfa2f53.png";